// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-hero-caption");

    if (carousel) {
      const carouselTrack = document.querySelector(
        ".carousel-hero-caption .wp-block-group"
      );
      const carouselSlides = carouselTrack.querySelector(
        ".carousel-hero-caption .wp-block-group .wp-block-group"
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-hero-caption .wp-block-group .wp-block-group .wp-block-cover"
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      var fullWidthGlide = new Glide(".carousel-hero-caption", {
        type: "carousel",
        perView: 1,
        autoplay: 4000,
        peek: 0,
        gap: 0,
      }).mount();
    }
  }
}

export default CarouselHeroCaption;
